module.exports = __webpack_public_path__ + "7e19c090ead95bfae22f48ff366b3cf9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/header/logo.png
// module id = ./assets/images/header/logo.png
// module chunks = 0